const body = document.querySelector('body');

const recapOpen = document.querySelectorAll('[recap-open]');
const recapClose = document.querySelectorAll('[recap-close]');
const recap = document.getElementById('recap-modal');

const recapiFrame = document.querySelector('#recap-modal iframe');
const recapPlayer = new Vimeo.Player(recapiFrame);
let isRecapOpen = false;

function openRecap() {
	recap.classList.add('modal-open');
	body.classList.add('scroll-lock');
	isRecapOpen = true;

	recapPlayer.play();
}

function closeRecap() {
	recap.classList.remove('modal-open');
	body.classList.remove('scroll-lock');
	isRecapOpen = false;

	recapPlayer.pause();
}

recapOpen.forEach(function(link) {
	link.addEventListener('click', function(event) {
		event.preventDefault();
		openRecap();
	});
});

recapClose.forEach(function(link) {
	link.addEventListener('click', function(event) {
		event.preventDefault();
		closeRecap();
	});
});


document.addEventListener("readystatechange", (event) => {
	if (document.readyState === "complete") {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		if (urlParams.get('promo-video') === 'true') {
			openRecap();
		}
	}
});

function promoQuery() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	if (urlParams.get('promo-video') === 'true') {
		openRecap();
	}
}

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	document.addEventListener("DOMContentLoaded", promoQuery);
} else {
	// `DOMContentLoaded` has already fired
	promoQuery();
}


const dirtyCoinOpen = document.querySelectorAll('[dirty-coin-open]');
const dirtyCoinClose = document.querySelectorAll('[dirty-coin-close]');
const dirtyCoin = document.getElementById('dirty-coin-modal');
const dirtyCoiniFrame = document.querySelector('#dirty-coin-modal iframe');
const dirtyCoinPlayer = new Vimeo.Player(dirtyCoiniFrame);
let isDirtyCoinOpen = false;

function openDirtyCoin() {
	dirtyCoin.classList.add('modal-open');
	body.classList.add('scroll-lock');
	isDirtyCoinOpen = true;

	dirtyCoinPlayer.play();
}

function closeDirtyCoin() {
	dirtyCoin.classList.remove('modal-open');
	body.classList.remove('scroll-lock');
	isDirtyCoinOpen = false;

	dirtyCoinPlayer.pause();
}

dirtyCoinOpen.forEach(function(link) {
	link.addEventListener('click', function(event) {
		event.preventDefault();
		openDirtyCoin();
	});
});

dirtyCoinClose.forEach(function(link) {
	link.addEventListener('click', function(event) {
		event.preventDefault();
		closeDirtyCoin();
	});
});



document.addEventListener('keydown', function(event) {
	if (event.key === 'Escape') {
		if(isRecapOpen) { closeRecap(); }
		if(isDirtyCoinOpen) { closeDirtyCoin(); }
	}
});